import { AppointmentInfo } from "../entities/entities";
import { EntityManager, Repository } from "aurelia-orm";
import { autoinject } from 'aurelia-dependency-injection';

@autoinject()
export class AppointmentInfoService {

	repository: Repository;
	constructor(private entityManager: EntityManager) {
		this.repository = this.entityManager.getRepository(AppointmentInfo);
	}

	//Matches /api/tag on server.
	find(id:number) {
		return this.repository.find(id);
	}

}